export const INIT_STATE = {
  id: null,
  first_name: null,
  last_name: null,
  birth_date: null,
  phone: null,
  email: null,
  address_line1: null,
  city: null,
  state: null,
  zip_code: null,
  pcp: null,
  vip_number: null,
  pcp_practice: null,
  out_of_area: null,
  health_plan: null,
  member_id: null,
  plan_sponsor: null,
  program: null,
  eligible: null,
  patient_consented_to_notifications: null,
  support_messages: null,
  patient_notes: null,
  established: null,
  messages: null,
  cprs: null,
  completed_cprs: null,
  patient_portal_alerts: null,
  notifications: null,
  current: null,
  in_progress: {
    page: null,
    count: null,
    fetched: null,
    total: null,
  },
  completed: {
    page: null,
    count: null,
    fetched: null,
    total: null,
  },
  cpr_page: 1,
};

/* url params: notification_type
    'standard',
    'agent_message',
    'document',
    'cpr_rejection_reason'

  response options on a care plan requirement applicable to any status
  1 => 'confirm'
  5 => 'I already completed this Care Plan Requirement',
  6 => 'I need an order document from my PCP',
  7 => 'I have scheduled an appointment already with my PCP',
  8 => 'I do not intend on completing this Care Plan Requirement'
  9 => 'Extension'
*/

export const OOA = {
  CONFIRM_NON_PRIMARY_ORDER_ACKNOWLEDGEMENT:
    "Please be sure to complete this requirement. If you need an order or referral to complete it, please contact your PCP’s office at your earliest convenience.",
  CONFIRM_PRIMARY:
    "Please be sure to complete this requirement. If you need to schedule an appointment, please contact your PCP’s office at your earliest convenience.",
};

export const ONBOARDING_SUBHEADER =
  "Please read and complete the four patient onboarding modules listed below. They contain important information about your health plan, the wellPORTAL primary care network, and Your wellPORTAL. When you finish a module, click “Complete Step.” When you have finished all modules, click “Finish.”";

export const ONBOARDING_COMPLETED =
  "You have successfully completed all your patient onboarding modules. You can access this information at any time by clicking on Info Center in the left-hand navigation menu.";

export const PCP_LOCATIONS_HEADER =
  "Browse the many PCP locations in the wellPORTAL network by clicking the buttons in the map below or scrolling through our list.";
export const OUT_OF_AREA_PCP_ELECTION = {
  HEADER: "We are missing information about your PCP",
  BODY_1:
    "If you currently see (or plan on seeing) a PCP in the Aetna Choice POS II network, click “Enter PCP’s Information” below and provide as much information as possible.",
  BODY_2:
    "Out-of-area Healthy Living Program members can also see any PCP from the wellPORTAL network. To do so, click “Select a PCP” below.",
};

export const OUT_OF_AREA_CHANGE_PCP =
  "To edit your PCP's information click 'Edit PCP' below. To change your PCP to a PCP from the wellPORTAL network, click 'Select a PCP' below ";

export const ONBOARDING_OOA_ELECT_PCP_PROMPT =
  "We are missing information about your PCP. Click 'GO TO DASHBOARD' below and follow the prompts to enter your PCP details or select a wellPORTAL PCP.";

export const IN_AREA_PCP_ELECTION =
  "You have not yet selected a wellPORTAL PCP. Click below to find a PCP in your area.";

export const GENERAL_SUPPORT = {
  TITLE: "General Patient Support",
  SUBHEADER:
    "This message thread is for general patient questions. Write and submit your question below and a wellPORTAL care navigator will contact you within two business days.",
};

export const NOT_COMPLETED_PRIMARY_CODE = {
  BODY_1: "You recently reported that you completed a(n) ",
  BODY_2:
    "However, your PCP has no record of you competing this you may have completed a PCP visit, but it may not have been a(n) ",
  BODY_3: "Please call the VIP line ",
  BODY_4:
    "at your earliest convenience to speak with a wellPORTAL care navigator and schedule your ",
};

export const UNABLE_TO_VERIFY_COMPLETED = {
  BODY_1: "You recently reported that you completed a(n) ",
  BODY_2: "but we are unable to verify this since your PCP has not obtained your results.",
  PARAGRAPHS: [
    'If you have a copy of your results, please upload them by clicking on "MORE ACTIONS" button (top-right of this page) ad select "Upload Results"',
    'If you have not completed this care plan requirement, please schedule an appointment as soon as possible.Once it is scheduled click on "MORE ACTIONS" and select "Add appointment details".',
    'If you need an order or referral to comeplete this care plan requirement, click on "More Actions" and select "Request Order/Referral."',
    "Thank you for your help",
  ],
};

export const DASHBOARD = {
  GREETING: {
    HELLO: "Hello ",
    WELCOME: "Welcome to ",
    yWP: "Your wellPORTAL ",
    DASHBOARD: "Patient Engagement Dashboard",
    CALL_US: "Need assistance? Call us at ",
  },
  TITLE: "Care Plan Requirements",
  NOTIFICATIONS_1: " care plan requirement(s) are awaiting a response. ",
  NOTIFICATIONS_2: " to view notification details and respond.",
  CLICK: "Click on ",
  CPR: " to add/edit appointment details, reporting a care plan requirement as completed, ask us a question, or request an order/referral",
  NO_CPRS: "No (0) care plan requirements to show",
};

export const EXTENSION_PROMPT = "By what date will you be able to complete this requirement?";

export const PRIMARY_CPR_APPT_EDIT_FLASH_PRIMARY = `<b>IMPORTANT!</b>
<p>
This feature is <b>not</b> for scheduling appointments with your Primary Care Provider (PCP). It is only intended to <b>notify us if you’ve already scheduled an appointment directly</b> with your PCP.
<p />
<p>
If you need to schedule or change an appointment with your wellPORTAL PCP, please call or text the wellPORTAL VIP line at 702-533-4353 and we’ll be happy to assist you.
</p>
`;

export const PRIMARY_CPR_APPT_EDIT_FLASH_NONPRIMARY = `
<b>IMPORTANT!</b>
<p>
This feature is <b>not</b> for scheduling appointments with your provider. It is only intended to <b>notify us if you’ve already scheduled an appointment directly with your provider</b> to complete this requirement.
</p>
<p>
If you need to <b>schedule or change an appointment</b>, please call your provider directly.
</p>`;

export const EXTENSION_TEXT =
  "Care plan requirements can only be extended within 60 days of the original due date. You will not be able to select a new due date more than 60 days after the original due date. ";

export const EXTENSION_LIMIT_REACHED_PRIMARY = (vip_phone_number) => {
  return `This care plan requirement is over 60 days past due. Please call the wellPORTAL VIP line at ${ vip_phone_number } and schedule your appointment to avoid penalties and continue earning rewards from your health plan. Our call center is open from 8:00 am to 5:00 pm, Monday through Friday.`;
}

export const EXTENSION_LIMIT_REACHED_NONPRIMARY = (vip_phone_number) => {
  return `This care plan requirement is over 60 days past due. Please complete it immediately to avoid penalties and continue earning rewards from your health plan. Please call the wellPORTAL VIP at ${ vip_phone_number } for assistance.`
}

export const TASK_MESSAGE_FIELD = {
  label: "",
  disabled: "This message thread is now closed. Need assistance? Call us at ",
  placeholder:
    "Have a question? Submit a question here and a wellPORTAL care navigator will contact you within two business days.",
  buttonText: "Submit",
};

export const CONFIRM_CONFIRMATION_PROMPT = (date_type) => {
  if (date_type == "Appointment Date") {
    return {
      prompt: "Please confirm your scheduled appointment or edit appointment as needed",
      options: { yes: "Confirm", no: "Do Not Confirm" },
    };
  } else {
    return {
      prompt: "Do you intend to complete this care plan requirement?",
      options: { yes: "Yes", no: "No" },
    };
  }
};

export const CONFIRM_UPDATED_DUE_DATE = "Please confirm your updated due date or edit as needed";

export const CONFIRM_UPDATED_APPOINTMENT_DATE =
  "Please confirm your updated scheduled appointment or edit as needed";

export const INTEND_TO_COMPLETE = {
  prompt: "Do you intend to complete this care plan requirement?",
  options: { yes: "Yes", no: "No" },
};
export const APPOINTMENT = {
  nonprimary_prompt:  "Do you have an appointment scheduled?",
  prompt: "Have you already scheduled an appointment with your PCP?",
  options: { yes: "Yes", no: "No" },
};

export function needPcpElectionFromPcpPractice(pcpPractice) {
  let pcpPracticeName = pcpPractice.name;
  return `According to our records, you have selected ${ pcpPracticeName } as your preferred PCP practice but have not yet chosen an individual PCP. \n Click below to select a PCP from this practice.`
}

export const DID_COMPLETE = {
  prompt: "Did you complete this care plan requirement?",
  options: { yes: "Yes", no: "No" },
};

export const SELECTED_NO_PROMPT_TEXT =
  'In the box below, please tell us why you selected "no". If you have any questions about this requirement, please type them in the box below. Someone from wellPORTAL will contact you within two business days.';

export const DATE_PROVIDER_PROMPTS = {
  DOCUMENT:
    "If you have a document as proof of completing this requirement, please upload it below and click the Submit button. If you don’t have a document to submit, simply click Submit to continue.",
  COMPLETED: {
    dateText: "When did you complete this requirement?",
    providerText: "What is the name of the provider you completed this requirement with? ",
    type: "completed",
  },
  SCHEDULED: {
    dateText: "Please enter the date and time of your scheduled appointment:",
    providerText:
      "Please enter the name of the provider you have scheduled this requirement with: ",
    type: "scheduled",
  },
  DUE_DATE: {
    dateText: "Please enter a new due date for this requirement",
    type: "extension",
  },
};

export const DATE_PROVIDER_TYPE_OPTION_VALUE_MAPPING = {
  completed: 5,
  extension: 9,
  scheduled: 7,
};

export const BUTTON_TEXT = {
  COMPLETED: "Report as completed",
};

export const CALL_CENTER_TEXT = (vip_number) => {
  return (
    "If you have questions or require assistance, call the wellPORTAL VIP line at " +
    vip_number +
    ". Our call center is open Monday through Friday, 8:00am to 5:00pm"
  );
};
export const CALL_CENTER_TEXT_FOR_PRIMARY_CODE = (vip_number) => {
  return (
    "Please call/text the wellPORTAL VIP line to schedule your appointment at " +
    vip_number +
    ". Our call center is open from 8:00am to 5:00pm Monday through Friday."
  );
};

export const NO_APPOINTMENT_SCHEDULED_WITH_ORDER_TEXT =
  "Please schedule an appointment to ensure that you complete this care plan requirement on time and are eligible to earn the maximum rewards offered by your health plan.";

export const ORDER_REQUEST_PROMPT =
  "Do you need an order or referral from your PCP to schedule this care plan requirement?";

export const ORDER_REQUEST_PROMPT_CALL_CENTER_TEXT = (vip_number) => {
  return (
    "If you're unsure or require assistance, call the wellPORTAL VIP line at " +
    vip_number +
    ". Our call center is open from 8:00am to 5:00pm Monday through Friday."
  );
};

export const ORDER_REQUESTED_TEXT =
  "We have received your request for a referral/order. We will send you a notification once it is available for you to download.";

export const ORDER_UPLOADED_NO_REQUEST =
  "An order has been uploaded for this care plan requirement. You can view it by clicking on the document icon.";

export const ORDER_REQUEST_RECIEVED_TEXT =
  "The order you requested for this requirement has been uploaded. You can view it by clicking on the document icon.";

export const MESSAGE_SENT_SUCCESS =
  "We received your message. A wellPORTAL care navigator will contact you within two business days.";

export const CONSENT_TEXT =
  "Your wellPORTAL can send you direct text messages and/or emails to remind you of upcoming appointments. These messages contain details about your health care and do not require logging in to Your wellPORTAL to read them.";

export const NO_PHONE_PROMPT = {
  prompt: "It looks like we don't have a phone number on file.",
  subText: " Please provide the best mobile phone number to reach you via text message",
};

export const REMINDER_NOTIFICATION_CONSENT = {
  prompt:
    "Do you want to receive additional direct text messages/emails to remind you of this appointment?",
  options: [
    {
      text: "Yes, just text messages",
      value: "phone",
    },
    {
      text: "Yes, just emails",
      value: "email",
    },
    {
      text: "Yes, both text messages and emails",
      value: "both",
    },
    { text: "No, thank you", value: undefined },
  ],
};

export const REMINDER_SCHEDULE_PROMPT = {
  prompt:
    "Please select how often you want to receive direct text messages/emails about this care plan requirement. By default, we send these out eight, four, and two days before the scheduled appointment date.",

  options: [
    {
      text: "Notify me eight, four, and two days before the scheduled appointment date",
      value: "8-4-2",
    },
    {
      text: "Only notify me eight days before the scheduled appointment date",
      value: "8",
    },
    {
      text: "Only notify me four days before the scheduled appointment date",
      value: "4",
    },
    { text: "Only notify me two days before the scheduled appointment date", value: "2" },
  ],
};

export const FLASH = {
  CLICK_TO_FINISH:
    "Click to finish",
  PCP_ELECTED:
    "Thank you for selecting a wellPORTAL PCP. You can change your PCP at any time or browse our list of PCP's by location, by clicking on 'Change PCP' from the dashboard.",
  PCP_ELECTED_OUT_OF_AREA:
    "Thank you for providing your PCP's information. You can change your PCP at any time by clicking on 'Update PCP'. If you'd like to select  a PCP from the wellPORTAL network or simply browse our list of PCP's by location, click on 'Select a PCP' from the dashboard.",
  MESSAGE_RESPONSE_SUCCESS: "Thank you for your response.",
  MESSAGE_RESPONSE_ERROR: "There was an error submitting your response. Please try again later.",
  REPORTED_COMPLETED: "Thank you for reporting this as completed. We will verify with your PCP.",
  EXTENSION_DUE_DATE:
    "Your due date has been updated! Please confirm your updated due date or edit as needed.",
  EXTENSION_APPOINTMENT_DATE: "Your appointment has been updated! ",
  APPOINTMENT_SCHEDULED:
    "Thank you for updating us about your scheduled appointment. Please confirm your updated appointment or edit as needed.",
  APPOINTMENT_UPDATED_NO_CONFIRM_REQUIRED:
    "Thank you for updating us about your scheduled appointment.",
  ORDER_REQUESTED:
    "We have received your request for an order/refferal. We will send you a notification once it is available for you to download.",

  RESPONDED:
    "Thank you for submitting a response. Please complete your care plan requirement to ensure you earn the maximum incentive from your health plan.",
  REMINDER_CONFIRMED:
    "Thank you for confirming this care plan requirement. Please complete it to ensure you earn the maximum incentive from your health plan.",
  DUE_DATE_CONFIRMED:
    "Thank you for confirming this care plan requirement. Please complete it to ensure you earn the maximum incentive from your health plan.",
  APPOINTMENT_CONFIRMED:
    "Thank you for confirming your appointment. We’ll send you a reminder notification 15 days before it’s due.  We’ll also send you direct text/email reminders if you signed up for them.",
  REJECTED:
    "Thank you for submitting a response. We will review it and follow up with you in the next few days.",
  ERROR: "There was an error submitting your request. Try again later.",
  NUMBER_SAVED: "Success! Your number has been saved",
  ONBOARDING_COMPLETED:
    "Thank you for completing your patient onboarding modules. You can access this information at any time by clicking on Info Center in the left-hand navigation menu.",
  ACKNOWLEDGE: "Thank you for acknowledging our message.",
};
export const MOBILE_PIXEL_WIDTH = 800;

export const CPR_ICON_MAPPING = {
  "AWV - Annual Wellness Visit": "pcp_visit",
  "103 - Acute Care Visit": "pcp_visit",
  "103 - Acute Care Visit (Scheduled)": "pcp_visit",
  "001 - Newly Eligible - Establish Care": "pcp_visit",
  "003 - PCP Change - Establish Care": "pcp_visit",
  "102 - Required PCP Visit": "pcp_visit",
  "102 - Required PCP Visit - Establish Care": "pcp_visit",
  "103 - Acute Care Visit": "pcp_visit",
  "203B - Required Specialist Visit": "specialist",
  "203C - Required Lab Draw": "lab",
  "203D - Required Preventive Service": "specialist",
  "203E - Required Imaging/Diagnostic": "imaging",
  Default: "pcp_visit",
};

export const CPR_CODE_NAME_MAPPING = {
  "AWV - Annual Wellness Visit": "Required PCP Visit",
  "103 - Acute Care Visit": "Required PCP Visit",
  "103 - Acute Care Visit (Scheduled)": "Required PCP Visit",
  "001 - Newly Eligible - Establish Care": "Required PCP Visit",
  "003 - PCP Change - Establish Care": "Required PCP Visit",
  "102 - Required PCP Visit": "Required PCP Visit",
  "102 - Required PCP Visit - Establish Care": "Required PCP Visit",
  "103 - Acute Care Visit": "Required PCP Visit",
  "203B - Required Specialist Visit": "Required Specialist Visit",
  "203C - Required Lab Draw": "Required Lab Draw",
  "203D - Required Preventive Service": "Required Preventative Service",
  "203E - Required Imaging/Diagnostic": "Required Imaging/Diagnostic",
};

export const STATUS_MESSAGE = {
  ALERT_FOR_RESULTS:
    "To ensure processing of your reward, please obtain a copy of your results from your provider. You’ll be able to upload that documentation on Your wellPORTAL when we follow up with you about the completion of this care plan requirement.",
  CONFIRMATION: "Confirmation Required",
  FOLLOW_UP: "Follow Up",
  PAST_DUE: "Past Due",
  UPDATED: " Thank you for updating us about this requirement status. ",
  IN_REVIEW:
    "Thank you for updating us about this requirement status. We are reviewing your response.",
  RESPONSE_REQUIRED: "Response Required (answer the questions to update your status)",
  REJECTED: "Rejected",
  REJECTED_COMMENT: "You rejected this care plan requirement with the following comment: ",
  REJECTED_NO_COMMENT: "You rejected this care plan requirement on ",
  REJECTED_UPDATE: "We received your response. We will notify you when we have an update.",
  REPORTED_COMPLETED: "Reported Completed (verifying with PCP)",
  REPORTED_COMPLETED_WITH_DOCUMENT: "Reported Completed (verifying your results)",
  REPORTED_COMPLETED_TEXT: "You reported this care plan requirement completed with the following details:",
  QUESTION_SUBMITTED: "You sent us a message:",
  QUESTION_UPDATE: "We will notify you when we have an update.",
  CONFIRMED_UPDATED_DUE_DATE: "Confirmed",
  CONFIRMED_APPOINTMENT: "Appointment Confirmed",
  COMPLETED: "Completed",
  ORDER_REQUESTED_TEXT:
    "Confirmed. We have received your request for a referral/order. We will send you a notification once it is available for you to download.",
  ORDER_UPLOADED_NO_REQUEST:
    "An order has been uploaded for this requirement. You can view it by clicking on the document icon.",
  ORDER_REQUEST_RECIEVED_TEXT:
    "The order you requested for this requirement has been uploaded. You can view it by clicking on the document icon.",
};

export const COLON_CANCER_SCREENING = {
  PROMPT_1:
    "Please select the type of test and the name of the provider scheduled to do your colon cancer screening",
  PROMPT_2:
    "Please select the the type of test you completed and the name of the provider who completed your colon cancer screening",
  COLOGUARD_NO_INPUT:
    "  * Do not enter a provider if you are completing or have completed a Cologuard screening.",
};

export const TOOLTIP = {
  CPR_CARD_HEADER: {
    NOTIFCATION_BODY_1:
      "You have a notification for this care plan requirement and it needs a response. Click to view your notification.",
    NOTIFCATION_BODY_2: "Click to view your notification.",
    ALT: "   Your response is required. Answer the questions below to update your status.",
  },
  VIEW_NOTIFICATIONS: "Click to view your notifications",
  RESPONSE_REQUIRED: "Please respond by answering the questions below",
  ADD_APPOINTMENT_DETAILS:
    "If you have scheduled an appointment for this care plan requirement, please enter it here so we can send you accurate and timely notifications. If you don't have an appointment for this care plan requirement, please schedule one as soon as possible and let us know.",
  UPLOAD_DOCUMENT:
    "If you have already completed this care plan requirement but haven't provided a document as proof of completion, click here to upload your document.",
  REPORT_AS_COMPLETED:
    "If you have already completed this care plan requirement, click here to notify us and earn your reward.",
  REQUEST_AN_ORDER:
    "If you need an official order or referral from your PCP to schedule and complete this care plan requirement, click here and we’ll get that process started for you.",
  ASK_A_QUESTION:
    "Have a question about this care plan requirement? Click here to ask us. We’ll respond within 24 hours.",
  DOCUMENT_UPLOAD: "What are examples of valid documentation",
  DOCUMENT_UPLOAD_TITLE: "Examples of valid documentation include:",
  DOCUMENT_UPLOAD_EXAMPLES: [
    "An after - visit summary from your doctor’s medical record system",
    "A copy of a bill/invoice for this requirement",
    "A copy of your results",
    "An explanation of benefits (EOB) from your health plan related to this requirement",
  ],
};

export const FORM_COMPLETED = "This form is completed.";
export const FORM_NEEDS_RESPONSE = "This form needs a response.";
export const ADDITIONAL_COMMENTS = "Additional Comments";
export const NO_ADDITIONAL_MESSAGES = "No Additional Messages";
export const NO_NOTIFICATIONS = "No Additional Care Plan Requirement Notifications";
export const GO_TO_DASHBOARD = "Go to dashboard";
export const GO_TO_NOTIFICATIONS = "Go to notifications";
export const GO_TO_PCP_ELECTION = "Select a PCP";
export const STEPS_COMPLETED = "all steps completed";
export const CHINESE_AVAILABLE = "Accommodates Chinese Mandarin Speaking Patients 會說普通話";
export const SPANISH_AVAILABLE = "Accommodates Spanish Speaking Patients";
export const DETAILS = "Details";
export const OUR_PCP_LOCATIONS = "Our PCP Locations";
export const TRANSLATION_AVAILABLE = "Translation Services Available";
export const NO_MAP_DATA = "No map data available";
export const CONTACT_PCP = "To contact your PCP's office, please call:";
export const CHANGE_PCP = "Change PCP";
export const NO_PCPS = "0 Available PCPs";
export const PCPS_AVAILABLE = " Available PCPs";
export const YOUR_PCP_ADDRESS = "Your PCP's Practice Address";
export const LOADING = "...loading";
export const LOAD_MORE_CPRS = "Load more care plan requirements";
export const ALL_CPRS_LOADED = "All in progress care plan requirements loaded";
export const WHY_THIS_IS_REQUIRED = "Why this is required";
export const HIDE = "hide";
export const REWARDS = "Rewards";
export const REWARD = "Reward";
export const REWARD_OPPORTUNITY = "Reward Opportunity";
export const MESSAGES = "Messages";
export const BACK = "Back";
export const NEXT = "Next";
export const FINISH = "Finish";
export const COMPLETED = "completed";

export const MORE_ACTIONS = "More Actions";
export const ADD_APPOINTMENT = "Add appointment details";
export const EDIT_APPOINTMENT = "Edit appointment details";
export const REPORT_AS_COMPLETED = "Report as completed";
export const ASK_A_QUESTION = "Ask a question";
export const REQUEST_ORDER_REFERRAL = "Request an order/referral";
export const CLICK_TO_ACKNOWLEDGE = "click to acknowledge";
export const ORIGINAL_DUE_DATE = "Original Due Date: ";
